function toggleContainer() {
  let rightContainer = document.getElementsByClassName(
    "right-side--container"
  )[0];
  rightContainer.classList.toggle("hide-content");
  var container = document.querySelector(".toggle--container");
  container.classList.toggle("active");

  var divElement = document.querySelector(".main-total-care--container");
  divElement.classList.toggle("clicked");
}

function redirectToPage(url) {
  window.location.href = url;
}
function makePhoneCall() {
  window.location.href = "tel:1577-0933";
}
